module.exports = __webpack_public_path__ + "img/Group 97837.6c2c606a.png";